import {
  Box,
  Table,
  TableBody,
  TableContainer,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import TableRows from "./tableRows";

const OrderedProducts = ({ order_ }) => {
  const [subTotal, setTotal] = useState(0);

  useEffect(() => {
    const calculatedTotal = order_.filters.reduce((acc, filter) => {
      return acc + parseFloat(filter.subtotal);
    }, 0);
    setTotal(calculatedTotal);
  }, [order_]);

  return (
    <Box>
      <Typography sx={{ fontWeight: 500 }} textAlign={"center"} mb={2}>
        Bestilte varer
      </Typography>
      {order_.filters.map((filter, key) => (
        <TableContainer
          key={key}
          variant={"Paper"}
          sx={{ mb: 5, boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)" }}
        >
          <Table aria-label="simple table">
            <TableBody>
              <TableRows title={"Produkt"} value={<>{filter.description}<div style={{height : "7px"}} ></div><strong>{filter.ref}</strong></>} />
              <TableRows title={"Pris pr. stk"} value={`${filter.price} dkk`} />
              <TableRows title={"Antal"} value={filter.quantity} />
              <TableRows title={"Subtotal"} value={`${filter.subtotal} dkk`} />
              <TableRows title={"Total"} value={`${filter.subtotal} dkk`} />
            </TableBody>
          </Table>
        </TableContainer>
      ))}
      <TableContainer
        variant={"Paper"}
        sx={{ mb: 5, boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)" }}
      >
        <Table aria-label="simple table">
          <TableBody>
            <TableRows title={"Subtotal"} value={`${order_.subtotal} dkk`} />
            <TableRows title={"Fragtomkostninger"} value={`0 dkk`} />
            <TableRows title={"Total beløb"} value={`${order_.subtotal} dkk`} />
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default OrderedProducts;
